import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getAnalytics, isSupported } from "firebase/analytics";

export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyCu5IBSSDXxhMtT6hZSUS9xZDPWXye0lbY",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "bible-aicoder.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "bible-aicoder",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "bible-aicoder.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "426125199465",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:426125199465:web:e4927e0cea47de89783af8",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-8RSW6NGMX5",
};

const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();

export const auth = getAuth(app);
export const db = getFirestore(app);
export const googleProvider = new GoogleAuthProvider();

export let analytics = null;
if (typeof window !== "undefined") {
  isSupported()
    .then((yes) => {
      if (yes) {
        analytics = getAnalytics(app);
      }
    })
    .catch(() => {});
}

export default app;
